// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { IS_PROD } from "../constants/Config"
import { deleteToken, getMessaging, getToken } from "firebase/messaging"
import { getInstallations, deleteInstallations } from "firebase/installations"
import { postAPI } from "./api"

const firebaseConfig = IS_PROD
  ? {
      apiKey: "AIzaSyAqJEYdpD-Hz7KfCCHX1ye4AFpL2xmmu7Y",
      authDomain: "diglog-prod.firebaseapp.com",
      projectId: "diglog-prod",
      storageBucket: "diglog-prod.appspot.com",
      messagingSenderId: "423343295197",
      appId: "1:423343295197:web:56e555d68a55c2fc44a934",
      measurementId: "G-K29F9YG61X",
    }
  : {
      apiKey: "AIzaSyDM6gcmMQ97mCNclw13S8ucPEOwDtHMs_k",
      authDomain: "diglog-8b0ae.firebaseapp.com",
      projectId: "diglog-8b0ae",
      storageBucket: "diglog-8b0ae.appspot.com",
      messagingSenderId: "670072573715",
      appId: "1:670072573715:web:87a701b1731655b71e54e6",
      measurementId: "G-7H150KR29D",
    }

const app = initializeApp(firebaseConfig)

export const messaging = (() => {
  try {
    return getMessaging(app)
  } catch (e) {
    console.log(e)
    return null
  }
})()

const cleanupFirebaseSubscription = async () => {
  try {
    // Step 1: Delete existing FCM token if any
    if (messaging) {
      try {
        await deleteToken(messaging)
        console.log("Previous FCM token deleted")
      } catch (tokenError) {
        console.log("No previous token to delete or error:", tokenError)
      }
    }

    // Step 2: Delete Firebase installation to clear all topic subscriptions
    // topic subscription is tied to firebaseId, not just token.
    try {
      const installations = getInstallations()
      await deleteInstallations(installations)
      console.log("Firebase installation reset complete")
    } catch (installError) {
      console.log("No previous installation or error:", installError)
    }
  } catch (error) {
    console.error("Error during Firebase cleanup:", error)
    // Don't throw - allow token generation to proceed
  }
}

export const getFirebaseToken = async (
  defaultSwReg?: ServiceWorkerRegistration
) => {
  await navigator.serviceWorker.ready

  let swReg: ServiceWorkerRegistration | undefined
  if (defaultSwReg) {
    swReg = defaultSwReg
  } else if ("serviceWorker" in navigator) {
    swReg = await navigator.serviceWorker.getRegistration()
  }

  if (messaging === null) return

  return getToken(messaging, {
    vapidKey: IS_PROD
      ? "BGmspf1I5L6vdeGXbni_oESj9tZ0qvk4PUqROD7iVBGzdeHCeapPVgLP-ZDOAg_DOzL33glegRKCkF9Pn9OYDJs"
      : "BHOjjclbvvIULfTXPApKyCsw_qevvAT1IoS1pf4a9DFZlkdbZp3lRCEoAdRB03zrVyeI5lghxLDbnCdhOtO8sic",
    serviceWorkerRegistration: swReg,
  })
}

export const registerPushTokenWithServer = () => {
  const performRegistration = async () => {
    try {
      // wipe any old subscription
      await cleanupFirebaseSubscription()
      // tiny pause so cleanup has landed
      await new Promise((res) => setTimeout(res, 300))
      // grab fresh token
      const pushToken = await getFirebaseToken()

      // Only send to server if we have a valid token
      if (pushToken && pushToken.trim() !== "") {
        // post it up
        await postAPI("/businesses/notification/subscribe", { pushToken })
        console.log("Push token successfully registered with server")
      } else {
        console.warn("Skipping push registration: No valid token available")
      }
    } catch (e) {
      console.warn("Push registration failed:", e)
    }
  }

  // if SW not supported, do it now and bail
  if (!("serviceWorker" in navigator)) {
    performRegistration()
    return
  }

  // if already under SW control → register immediately
  if (navigator.serviceWorker.controller) {
    performRegistration()
    return
  }

  // otherwise, queue it to run once the SW is ready (activated & controlling)
  navigator.serviceWorker.ready
    .then(() => {
      // NB: by the time this resolves, controller will be non-null
      return performRegistration()
    })
    .catch((err) => {
      // SW never became ready (e.g. user never installed)… we just skip
      console.warn("Service worker never controlled the page:", err)
    })
}
